export const packagesObject = {
    packages: [],
    publicPackages: [],
    selectedPackage: null,
    isLoading: false,
    error: null,
};
